(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[780],{

/***/ 54644:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liked/shops",
      function () {
        return __webpack_require__(89068);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ LikedShopsPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10299);
/* harmony import */ var containers_liked_liked__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50887);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49532);
/* harmony import */ var services_like__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61960);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77712);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53218);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50959);
/* harmony import */ var hooks_useDebounce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57812);
/* harmony import */ var hooks_useRedux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46496);
/* harmony import */ var services_shop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67788);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89834);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var containers_settings_settings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72059);













function LikedShopsPage() {
    var ref;
    const { isAuthenticated  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .a)();
    const { i18n  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)();
    const { shopList  } = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_9__/* .useAppSelector */ .C)((state)=>state.liked);
    const lang = i18n.language;
    const debouncedShopList = (0,hooks_useDebounce__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(shopList, 500);
    const { data: serverLikedShops , isLoading: isServerLikedShopsLoading , isFetching: isServerLikedShopsFetching , hasNextPage , fetchNextPage  } = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useInfiniteQuery)({
        queryKey: [
            "likedShops",
            lang
        ],
        queryFn: (param)=>{
            let { pageParam =1  } = param;
            return services_like__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getAll */ .Z.getAll({
                type: "shop",
                perPage: 12,
                page: pageParam
            });
        },
        getNextPageParam: (lastPage)=>{
            var ref, ref1;
            if ((lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.meta) === null || ref === void 0 ? void 0 : ref.current_page) < (lastPage === null || lastPage === void 0 ? void 0 : (ref1 = lastPage.meta) === null || ref1 === void 0 ? void 0 : ref1.last_page)) {
                var ref2;
                return (lastPage === null || lastPage === void 0 ? void 0 : (ref2 = lastPage.meta) === null || ref2 === void 0 ? void 0 : ref2.current_page) + 1;
            }
        },
        enabled: isAuthenticated,
        staleTime: 0
    });
    const { data: localLikedShops , isLoading: isLocalLikedShopsLoading  } = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)({
        queryKey: [
            "likedUnAuthShops",
            lang,
            debouncedShopList
        ],
        queryFn: ()=>{
            const params = {
                perPage: 100,
                ...debouncedShopList.reduce((acc, curr, index)=>({
                        ...acc,
                        ["ids[".concat(index, "]")]: curr.shopId
                    }), {})
            };
            return services_shop__WEBPACK_IMPORTED_MODULE_10__/* ["default"].getAll */ .Z.getAll(qs__WEBPACK_IMPORTED_MODULE_12___default().stringify(params));
        },
        enabled: !isAuthenticated && !!debouncedShopList.length,
        keepPreviousData: true,
        staleTime: 0
    });
    const extractedServerLikedShops = serverLikedShops === null || serverLikedShops === void 0 ? void 0 : (ref = serverLikedShops.pages) === null || ref === void 0 ? void 0 : ref.flatMap((page)=>{
        return (page === null || page === void 0 ? void 0 : page.data) || [];
    });
    const actualList = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(()=>{
        if (isAuthenticated) {
            return extractedServerLikedShops || [];
        }
        if (shopList.length) {
            return (localLikedShops === null || localLikedShops === void 0 ? void 0 : localLikedShops.data) || [];
        }
        return [];
    }, [
        isAuthenticated,
        extractedServerLikedShops,
        localLikedShops,
        shopList
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_settings_settings__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_liked_liked__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    type: "shop",
                    data: actualList,
                    isLoading: isAuthenticated ? isServerLikedShopsLoading && isServerLikedShopsFetching : isLocalLikedShopsLoading,
                    hasNextPage: hasNextPage,
                    isFetchingNextPage: isServerLikedShopsFetching,
                    fetchingNextPage: fetchNextPage
                })
            })
        ]
    });
}


/***/ }),

/***/ 67788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47137);

const shopService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?".concat(params)),
    getAllBooking: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/booking/shops/paginate?".concat(params)),
    getAllRestaurants: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?type=restaurant&".concat(params)),
    getAllShops: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?type=shop&".concat(params)),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/search", {
            params
        }),
    getAllTags: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-takes", {
            params
        }),
    create: (data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/dashboard/user/shops", data),
    checkZone: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/delivery-zone/check/distance", {
            params
        }),
    checkZoneById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/".concat(id, "/delivery-zone/check/distance"), {
            params
        }),
    getVisitedShops: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-histories/paginate", {
            params
        }),
    getByIds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/ids", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (shopService);


/***/ }),

/***/ 71568:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8396,2426,78,9774,2888,179], function() { return __webpack_exec__(54644); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);